export default __webpack_public_path__ + "static/media/img-7.2a805193.jpg";